class ChatRepository {
  constructor(chatApiService, localStorageService, videoCallSocketService, voiceCallSocketService, messagingSocketService, encryptionService) {
    if (new.target === ChatRepository) {
      throw new Error("Cannot instantiate an abstract class.");
    }
    if (this.sendMessage === ChatRepository.prototype.sendMessage) {
      throw new Error("Class extending ChatRepository must override 'sendMessage({ message, uniqueKey })'.");
    }
    if (this.getPreviousMessages === ChatRepository.prototype.getPreviousMessages) {
      throw new Error("Class extending ChatRepository must override 'getPreviousMessages({ chatChannelId, currentMessagesCount })'.");
    }
    if (this.startMessaging === ChatRepository.prototype.startMessaging) {
      throw new Error(
        "Class extending ChatRepository must override 'startMessaging({ resultCallback, errorCallback, noCreditsCallback, statusCallback, aiStatusCallback, aiResponseCallback, messageStatusCallback })'."
      );
    }
    if (this.startVideoCall === ChatRepository.prototype.startVideoCall) {
      throw new Error("Class extending ChatRepository must override 'startVideoCall(chatChannelId, resultCallback)'.");
    }
    if (this.endVideoCall === ChatRepository.prototype.endVideoCall) {
      throw new Error("Class extending ChatRepository must override 'endVideoCall(chatChannelId)'.");
    }
    if (this.startVoiceCall === ChatRepository.prototype.startVoiceCall) {
      throw new Error(
        "Class extending ChatRepository must override 'startVoiceCall({ chatChannelId, callConversation, callStatusCallback, noCreditsCallback, aiModeCallback, errorCallback })'."
      );
    }
    if (this.endVoiceCall === ChatRepository.prototype.endVoiceCall) {
      throw new Error("Class extending ChatRepository must override 'endVoiceCall()'.");
    }
    this.chatApiService = chatApiService;
    this.localStorageService = localStorageService;
    this.videoCallSocketService = videoCallSocketService;
    this.voiceCallSocketService = voiceCallSocketService;
    this.messagingSocketService = messagingSocketService;
    this.encryptionService = encryptionService;
  }

  async sendMessage({ message, uniqueKey }) {
    throw new Error("Method 'sendMessage({ message, uniqueKey })' must be implemented.");
  }

  async getPreviousMessages({ chatChannelId, currentMessagesCount }) {
    throw new Error("Method 'getPreviousMessages({ chatChannelId, currentMessagesCount })' must be implemented.");
  }

  async startMessaging({
    resultCallback,
    errorCallback,
    noCreditsCallback,
    statusCallback,
    aiStatusCallback,
    aiResponseCallback,
    messageStatusCallback,
  }) {
    throw new Error(
      "Method 'startMessaging({ resultCallback, errorCallback, noCreditsCallback, statusCallback, aiStatusCallback, aiResponseCallback, messageStatusCallback })' must be implemented."
    );
  }

  async startVideoCall(chatChannelId, resultCallback) {
    throw new Error("Method 'startVideoCall(chatChannelId, resultCallback)' must be implemented.");
  }

  async endVideoCall(chatChannelId) {
    throw new Error("Method 'endVideoCall(chatChannelId)' must be implemented.");
  }

  async startVoiceCall({ chatChannelId, callConversation, callStatusCallback, noCreditsCallback, aiModeCallback, errorCallback }) {
    throw new Error(
      "Method 'startVoiceCall({ chatChannelId, callConversation, callStatusCallback, noCreditsCallback, aiModeCallback, errorCallback })' must be implemented."
    );
  }

  async endVoiceCall() {
    throw new Error("Method 'endVoiceCall()' must be implemented.");
  }
}

export default ChatRepository;
